import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { ErrorService } from '../helpers/errorService';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SummaryService {
  constructor(
    private http: HttpClient,
    private errorService: ErrorService
  ) { }

  // Per-plan summary endpoints. Add a new plan here + a backend endpoint to
  // extend the summary to more EOPs — the component stays generic.
  private summaryEndpointByPlan: { [plan: string]: string } = {
    'al': endpoints.alEopSummary,
    'ms': endpoints.msEopSummary,
    'ga': endpoints.gaEopSummary,
  };

  // None of these are school-year scoped: the summary reports each section's
  // latest activity, so a section is never blanked by the year it falls in.
  getSummary(plan: string, buildingId: string): Observable<{has_error: boolean, message: string, data: any}> {
    const template = this.summaryEndpointByPlan[plan] ?? endpoints.alEopSummary;
    const url = environment.apiBaseUrl + template.replace(':buildingId', buildingId);

    return this.http.get<{has_error: boolean, message: string, data: any}>(url).pipe(
        catchError(this.errorService.handleError)
    );
  }

  getEoPSummary(buildingId: string): Observable<{has_error: boolean, message: string, data: any}> {
    const url = environment.apiBaseUrl + endpoints.eopSummary.replace(':buildingId', buildingId);

    return this.http.get<{has_error: boolean, message: string, data: any}>(url).pipe(
        catchError(this.errorService.handleError)
    );
  }

  getAlEopSummary(buildingId: string): Observable<{has_error: boolean, message: string, data: any}> {
    const url = environment.apiBaseUrl + endpoints.alEopSummary.replace(':buildingId', buildingId);

    return this.http.get<{has_error: boolean, message: string, data: any}>(url).pipe(
        catchError(this.errorService.handleError)
    );
  }

  getMsEopSummary(buildingId: string): Observable<{has_error: boolean, message: string, data: any}> {
    const url = environment.apiBaseUrl + endpoints.msEopSummary.replace(':buildingId', buildingId);

    return this.http.get<{has_error: boolean, message: string, data: any}>(url).pipe(
        catchError(this.errorService.handleError)
    );
  }
}